import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

export const EmbeddedVideo = {
  Wrapper: styled.div`
    box-sizing: border-box;
    border-radius: ${px2rem(7)};
    position: relative;
    border: solid ${px2rem(1)} ${props => props.theme.grey300};
    width: 100%;
    overflow: hidden;
  `,

  IFrame: styled.iframe`
    width: 100%;
    margin: 0;
    padding: 0;
    border: 0;
  `,

  Figure: styled.div`
    position: relative;
  `,

  BlurHashWrapper: styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: ${props => props.theme.zBelow};
  `,

  Footer: styled.a`
    display: flex;
    align-items: center;
    width: 100%;
    height: ${px2rem(30)};
    padding-left: ${px2rem(8)};
    text-decoration: none;
  `,

  Host: styled.span`
    font-size: ${px2rem(11)};
    font-weight: ${props => props.theme.weightMedium};
    color: ${props => props.theme.grey700};
    margin-right: ${px2rem(4)};
  `,
};
